export function fixGeometry(canvas: HTMLCanvasElement, container: HTMLDivElement, resolution: string, aspectRatio: string) {
  // Get container dimensions
  const containerWidth = container.clientWidth;
  const containerHeight = container.clientHeight;

  // PiolaCraft: el letterbox se hace por CSS (tamaño visual explícito +
  // contenedor flex centrado). Antes el recorte de aspecto se aplicaba solo
  // al buffer del canvas con CSS al 100%: el buffer y lo visual quedaban
  // desincronizados y el juego se veía corrido a la izquierda con toda la
  // banda negra a la derecha.

  // Tamaño VISUAL: lo máximo que entra en el contenedor respetando la
  // relación de aspecto elegida (any = llenar).
  let cssWidth = containerWidth;
  let cssHeight = containerHeight;
  if (aspectRatio !== 'any') {
    const ratioValues = aspectRatio.split(':').map(Number);
    if (ratioValues.length === 2 && !ratioValues.includes(NaN) && ratioValues[1] !== 0) {
      const targetRatio = ratioValues[0] / ratioValues[1];
      if (containerWidth / containerHeight > targetRatio) {
        cssWidth = Math.floor(containerHeight * targetRatio);
      } else {
        cssHeight = Math.floor(containerWidth / targetRatio);
      }
    }
  }

  // Resolución interna (buffer) = escala del tamaño visual.
  let resolutionFactor = 1.0;
  switch (resolution) {
    case 'low':
      resolutionFactor = 0.5;
      break;
    case 'medium':
      resolutionFactor = 0.75;
      break;
    case 'high':
    default:
      resolutionFactor = 1.0;
      break;
  }

  // PISO de resolución: nunca bajar de ~960px de ancho (salvo que la propia
  // ventana sea más chica). Con ventanas medianas, "Baja" daba buffers de
  // 625x289 o menos: la LETRA del juego tiene tamaño fijo en píxeles, así
  // que los textos desbordaban los botones de los menús (que sí se achican
  // para entrar) y todo se veía gigante y roto.
  const PC_MIN_BUFFER_W = 960;
  if (cssWidth * resolutionFactor < PC_MIN_BUFFER_W) {
    resolutionFactor = Math.min(1.0, PC_MIN_BUFFER_W / cssWidth);
  }

  // Set canvas dimensions
  canvas.width = Math.floor(cssWidth * resolutionFactor);
  canvas.height = Math.floor(cssHeight * resolutionFactor);

  // Tamaño visual explícito + centrado: con aspecto fijo, las bandas negras
  // quedan simétricas (el fondo negro lo pone el contenedor).
  canvas.style.width = cssWidth + 'px';
  canvas.style.height = cssHeight + 'px';
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.justifyContent = 'center';
  container.style.backgroundColor = '#000';

  // Notify the Module if it exists
  if (window.Module && window.irrlicht_resize) {
    window.irrlicht_resize(canvas.width, canvas.height);
  }
}

export function queryProxy(cmd: string, proxy: string) {
  return new Promise<[string, string, string]>((resolve, reject) => {
    let finished = false;
    // eslint-disable-next-line no-console
    console.log('[MP proxy] queryProxy:', cmd, '->', proxy);
    const ws = new WebSocket(proxy);
    // Timeout: sin esto, si el proxy no responde el juego se queda colgado.
    const timer = setTimeout(() => {
      if (finished) return;
      finished = true;
      // eslint-disable-next-line no-console
      console.error('[MP proxy] TIMEOUT (10s) esperando respuesta a: ' + cmd);
      try { ws.close(); } catch (e) { /* */ }
      reject(new Error('proxy timeout'));
    }, 10000);
    ws.addEventListener('open', () => {
      // eslint-disable-next-line no-console
      console.log('[MP proxy] WS abierto, enviando: ' + cmd);
      ws.send(cmd);
    });
    ws.addEventListener('error', (event) => {
      if (finished) return;
      finished = true; clearTimeout(timer);
      // eslint-disable-next-line no-console
      console.error('[MP proxy] WS error', event);
      reject(new Error('proxy error'));
    });
    ws.addEventListener('close', (event) => {
      if (finished) return;
      finished = true; clearTimeout(timer);
      // eslint-disable-next-line no-console
      console.error('[MP proxy] WS cerrado inesperado. code=' + event.code + ' reason=' + event.reason);
      reject(new Error('proxy closed'));
    });
    ws.addEventListener('message', (event) => {
      if (finished) return;
      clearTimeout(timer);
      // eslint-disable-next-line no-console
      console.log('[MP proxy] respuesta: ' + event.data);
      if (typeof event.data !== 'string') {
        finished = true;
        reject(new Error('Invalid message'));
        return;
      }
      finished = true;
      ws.close();
      resolve(event.data.split(' ') as [string, string, string]);
    });
  });
}